import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getMissingContact } from '../../../LambdaFunctions/shared/personalContact';
import './contactDetails.scss';

let tooltipSequence = 0;

export default function ContactDetailsMissing({ email, mobile, field }) {
  const [tooltipId] = useState(() => `missing-contact-${++tooltipSequence}`);
  const missing = getMissingContact({ email, mobile });
  const icons = [
    ['mobile', missing.missingMobile, 'Brak telefonu', 'fa-phone-slash'],
    ['email', missing.missingEmail, 'Brak e-maila', 'fa-envelope'],
  ].filter(([key, absent]) => absent && (!field || field === key));
  if (!icons.length) return null;
  return (
    <span className="contact-missing-icons">
      {icons.map(([key, , label, icon]) => (
        <OverlayTrigger key={key} placement="top" overlay={<Tooltip id={`${tooltipId}-${key}`}>{label}</Tooltip>}>
          <span
            className="contact-missing-icon"
            role="img"
            aria-label={label}
            tabIndex={0}
            onClick={event => { event.stopPropagation(); event.currentTarget.focus(); }}
            onKeyDown={event => event.stopPropagation()}
          ><i className={`fas ${icon}`} aria-hidden="true" /></span>
        </OverlayTrigger>
      ))}
    </span>
  );
}

ContactDetailsMissing.propTypes = { email: PropTypes.string, mobile: PropTypes.string, field: PropTypes.oneOf(['email', 'mobile']) };
ContactDetailsMissing.defaultProps = { email: '', mobile: '', field: undefined };
